import React from 'react';

const Page = (props) => {
   return(
      <main className="page" data-view={props.view}>
         <div className="page__bg">
            <img className="page__bg-image" src={props.bg} alt=""/> 
         </div>
         <div className="container">
            <div className="row page__constrain">
               <div className="col-md-12">
                  {props.children}
               </div>
            </div>
         </div>
      </main>
   )
}

export default Page;